import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import RCTMultiFileConfigure from '../../../../../Measurement/_components/RCT/RCTMultiFileConfigure'

interface Props {
    _ref: any
    tabledata: any
    literal: string
    onContinue: () => void
    onPrevious: () => void
}

const RCTMultiFileMeasurementConfigureModal: React.FC<Props> = ({ _ref, tabledata, literal, onContinue, onPrevious }) => {
    const { t } = useTranslation()
    const [show, setShow] = useState<boolean>(false)

    useEffect(() => {
        if (_ref?.current) {
            const originalShowModal = _ref.current.showModal
            _ref.current.showModal = function () {
                setShow(true)
                originalShowModal.call(this)
            }

            _ref.current.addEventListener('cancel', () => {
                setShow(false)
            })
        }
    }, [])

    return (
        <dialog ref={_ref} className="modal">
            <div className="modal-box w-11/12 max-w-5xl">{show && <RCTMultiFileConfigure tabledata={tabledata} literal={literal} onContinue={onContinue} onPrevious={onPrevious} />}</div>
            <form method="dialog" className="modal-backdrop">
                <button type="button">{t('close')}</button>
            </form>
        </dialog>
    )
}

export default RCTMultiFileMeasurementConfigureModal
